var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgABTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.5 21.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5,11.19a.53.53,0,0,1-.24-.06.5.5,0,0,1-.2-.68L5.5.24a.53.53,0,0,1,.89,0l2.68,5A.5.5,0,0,1,8.86,6a.49.49,0,0,1-.67-.21L6,1.54l-5,9.38A.5.5,0,0,1,.5,11.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78,8.23h-3a.5.5,0,1,1,0-1h3a.5.5,0,1,1,0,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.78,
    y: 7.23,
    width: 3,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.51,11.23H16.78a.5.5,0,0,1,0-1h3.73a2,2,0,0,0,2-2,2,2,0,0,0-2-2H18.24a.5.5,0,0,1,0-1h.27a2.27,2.27,0,0,0,2.27-2,2.27,2.27,0,0,0-2.27-2H15.78v4a.5.5,0,0,1-1,0V.73a.5.5,0,0,1,.5-.5h3.23a3.23,3.23,0,0,1,3.27,3,2.87,2.87,0,0,1-.9,2,3,3,0,0,1,2.62,3A3,3,0,0,1,20.51,11.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.61,21.71a.48.48,0,0,1-.46-.32l-3-7.61a.5.5,0,0,1,.94-.36l3,7.6a.51.51,0,0,1-.28.65A.43.43,0,0,1,16.61,21.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.91,14.43a5.28,5.28,0,1,1,1.91-.37A5,5,0,0,1,11.91,14.43Zm0-9.53a4.4,4.4,0,0,0-1.56.29,4.27,4.27,0,0,0,1.56,8.24,4.15,4.15,0,0,0,1.55-.3A4.26,4.26,0,0,0,11.91,4.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgABTest);
export default __webpack_public_path__ + "static/media/a-b-test.ab4cf8ffea486307d505c07758fac46f.svg";
export { ForwardRef as ReactComponent };